export default "__VITE_ASSET__CNSM8KPF__";